import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../global-constants";
import { PlatformService } from "../platform/platform.service";
import { DetalleBlog, ListaBlogs } from "@src/app/models/interfaces/blog.interface";

@Injectable()
export class BlogService {
  private readonly API_URL: string;
  private readonly constantesGlobales: any;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    this.constantesGlobales = new GlobalConstants(host);
    this.API_URL = this.constantesGlobales.urlApi;
  }

  public getListadoBlogs(idAmbito: number): Observable<ListaBlogs[]> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    const body = new HttpParams().set("id_ambito", String(idAmbito));

    return new Observable<ListaBlogs[]>((observer) => {
      this.httpClient.get<ListaBlogs[]>(this.API_URL + "/listadoBlogs", { headers: headers, params: body }).subscribe({
        next: (data) => {
          observer.next(data);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }

  public getPostsBlog(numeroVideos: number, searchBy: string, filterBy = "id"): Observable<DetalleBlog> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    if (!numeroVideos) {
      numeroVideos = 1;
    }
    const body = new HttpParams().set("limit_videos", String(numeroVideos)).set("search_by", searchBy).set("filter_by", filterBy);

    return new Observable<DetalleBlog>((observer) => {
      this.httpClient.get<DetalleBlog>(this.API_URL + "/getPostsBlog", { headers: headers, params: body }).subscribe({
        next: (data) => {
          observer.next(data);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }
}
